import * as React from "react";
import { useFocusEffect, useNavigation } from "expo-router";

import SaveFormSelectLocation from "~/components/SaveForm/SaveForm.selectLocation";

export default function SelectLocation() {
  const accountLayout = useNavigation("/(app)/(authenticated)/[account]");
  useFocusEffect(() => {
    accountLayout.setOptions({
      sheetAllowedDetents: "fitToContents",
    });
  });

  return <SaveFormSelectLocation />;
}

// TODO: Refactor these to be independent of parent form.
// moveTo and copyTo uses these too
